import { render, staticRenderFns } from "./guess-panel.vue?vue&type=template&id=36053da2&scoped=true"
import script from "./guess-panel.vue?vue&type=script&lang=js"
export * from "./guess-panel.vue?vue&type=script&lang=js"
import style0 from "./guess-panel.vue?vue&type=style&index=0&id=36053da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36053da2",
  null
  
)

export default component.exports